import { render } from "./request-base-address.vue?vue&type=template&id=f4a4d3ca&scoped=true&ts=true"
import script from "./request-base-address.vue?vue&type=script&lang=ts"
export * from "./request-base-address.vue?vue&type=script&lang=ts"

import "./request-base-address.vue?vue&type=style&index=0&id=f4a4d3ca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4a4d3ca"]])

export default __exports__